import Vue from 'vue'
import Router from 'vue-router'
// 开发阶段不采用lazy loading
const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)
export const constantRouterMap = [
  {
    // 入口
    path: '/',
    redirect: '/tikuTourist',
    component: _import('tikuTourist/index'),
    meta: {
      title: '题库'
    }
  },
  {
    // 题库游客模式
    path: '/tikuTourist',
    component: _import('tikuTourist/index'),
    meta: {
      title: '题库未登录'
    }
  },
  {
    // 购买协议
    path: '/agreement',
    component: _import('agreement/index'),
    meta: {
      title: '购买须知'
    }
  },
  {
    // APP版本号
    path: '/version',
    component: _import('version/index'),
    meta: {
      title: '关于APP'
    }
  },
  {
    // 恒企文化
    path: '/hqCulture',
    name: 'hqCulture',
    component: _import('hqCulture/index'),
    meta: {
      title: '恒企文化'
    }
  },
  {
    // 下载APP
    path: '/downloadAPP',
    component: _import('downloadAPP/index'),
    meta: {
      title: '恒企会计客户端下载'
    }
  },
  {
    // 下载APP-IOS安装流程
    path: '/iPhone',
    component: _import('downloadAPP/ios'),
    meta: {
      title: 'iPhone客户端下载'
    }
  },
  {
    // 邀请页
    path: '/invite',
    component: _import('invite/index'),
    meta: {
      title: '邀请'
    }
  },
  {
    // 课程详情
    path: '/course',
    component: _import('course/index'),
    meta: {
      title: '课程详情'
    }
  },
  {
    // 最新头条
    path: '/entry',
    component: _import('entry/index'),
    meta: {
      title: '最新头条'
    }
  },
  {
    // 休学申请 Take an examination
    path: '/leaveSchool',
    component: _import('leaveSchool/index'),
    meta: {
      title: '休学申请'
    }
  },
  {
    // 报考申请
    path: '/takeAnExamination',
    component: _import('takeAnExamination/index'),
    meta: {
      title: '报考申请'
    }
  },
  {
    // 弃考申请
    path: '/giveUp',
    component: _import('giveUp/index'),
    meta: {
      title: '弃考申请'
    }
  },
  {
    // 免考申请
    path: '/exempting',
    component: _import('exempting/index'),
    meta: {
      title: '免考申请'
    }
  },
  {
    // 成绩登记
    path: '/achievement',
    component: _import('achievement/index'),
    meta: {
      title: '成绩登记'
    }
  },
  {
    // 消息通知
    path: '/richText',
    component: _import('richText/index'),
    meta: {
      title: '消息通知'
    }
  },
  {
    // 服务条款
    path: '/clause',
    component: _import('clause/index'),
    meta: {
      title: '服务条款'
    }
  },
  {
    // 404
    path: '/404',
    component: _import('404/index'),
    meta: {
      title: '404'
    }
  },
  {
    // 机考报考
    path: '/computerList',
    component: _import('computerList/index'),
    meta: {
      title: '机考报考'
    }
  },
  {
    // 机考报考
    path: '/examTicket',
    component: _import('computerList/examTicket'),
    meta: {
      title: '准考证'
    }
  },
  {
    // 机考报考-详情
    path: '/computerDetails',
    component: _import('computerDetails/index'),
    meta: {
      title: '报考详情'
    }
  },
  {
    // 机考报考-报考申请信息
    path: '/computerExamFillIn',
    component: _import('computerExamFillIn/index'),
    meta: {
      title: '报考申请信息'
    }
  },
  {
    // 讲义
    path: '/lectureNote',
    component: _import('lectureNote/index'),
    meta: {
      title: '讲义详情'
    }
  },
  {
    // 问卷调研
    path: '/surveyPaper',
    component: _import('surveyPaper/index'),
    meta: {
      title: '问卷调研'
    }
  },
  {
    path: '/computerExamConfirm',
    component: _import('computerExamFillIn/computerExamConfirm'),
    meta: {
      title: '报考信息确认'
    }
  },
  { // 团长
    path: '/myTeam',
    component: _import('teamStudy/myTeam'),
    meta: {
      title: '组团学习'
    }
  },
  { // 被邀请者
    path: '/invited',
    component: _import('teamStudy/invited'),
    meta: {
      title: '组团学习'
    }
  },
  { // 好礼等你拿
    path: '/tkGift',
    component: _import('tkGift/index'),
    meta: {
      title: '好礼等你拿'
    }
  },
  {
    // 页面路径错误
    path: '*',
    component: _import('404/index')
  }
  // {
  //   // 页面报错
  //   path: '*',
  //   component: _import('404/404')
  // }
]
export default new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js